<template>
    <!-- <router-view v-slot="{ Component }">
        <transition name="van-fade">
            <component :is="Component" />
        </transition>
    </router-view> -->
    <router-view />
</template>